import React, {useContext, useEffect} from 'react';
import {toast} from 'react-toastify';
import {Trans} from 'react-i18next';
import {useAppDispatch} from '../../redux/store';
import SpotifyApiContext from '../../spotify/spotifyApiContext';
import {playerStoreSlice} from '../../redux/player/player.slice';
import AuthenticatorContext from '../authenticatorContext';
import SpotifyNowPlaying from '../../spotify/spotifyNowPlaying';

import './tokenChecker.css';

export const TokenChecker: () => JSX.Element = () => {
  const api = useContext(SpotifyApiContext);
  const authenticator = useContext(AuthenticatorContext);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const showReauthorizationToast = () => {
      authenticator.getAuthRedirectUrl().then((authUrl) => {
        toast(
          <Trans i18nKey="Reauthorize">
            Session expired. Please, <a className="reauthorizeButton" href={authUrl}>reauthorise</a>
          </Trans>,
          {
            toastId: 'toast-reauthorize',
            type: 'error',
            autoClose: false,
          },
        );
      });
    };

    const nowPlayingCall = async () => {
      api.getNowPlaying()
        .then((nowPlaying: SpotifyNowPlaying | null) => {
          dispatch(playerStoreSlice.actions.setNowPlaying(nowPlaying));
        })
        .catch(async (request: XMLHttpRequest) => {
          if (request.status === 401) {
            // Attempt to refresh the token before showing reauthorization toast
            const refreshedToken = await authenticator.refreshAccessToken();
            if (refreshedToken) {
              // Update API with new token and retry the call
              api.updateAccessToken(refreshedToken.token);
              try {
                const nowPlaying = await api.getNowPlaying();
                dispatch(playerStoreSlice.actions.setNowPlaying(nowPlaying));
              } catch (retryError) {
                // If retry still fails, show reauthorization toast
                showReauthorizationToast();
              }
            } else {
              // Refresh failed, show reauthorization toast
              showReauthorizationToast();
            }
          }
        });
    };

    nowPlayingCall();
    window.setInterval(nowPlayingCall, 10 * 1000);
  }, [api, dispatch, authenticator]);

  return (<></>);
};

